import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getSeoForPath, normalizePath } from "../config/seo";

/**
 * Global SEO defaults for static routes.
 * Skip /blog-details/* so BlogDetail Helmet (per-post meta) is not overwritten
 * with the homepage title/description that Google was indexing.
 */
const Seo = () => {
  const { pathname } = useLocation();
  const path = normalizePath(pathname);

  if (path.startsWith("/blog-details")) {
    return null;
  }

  const { title, description, canonical } = getSeoForPath(pathname);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default Seo;
